// extracted by mini-css-extract-plugin
export default {"root":"GlobalNotificationBanner_root__nvthA","appearAnimation":"GlobalNotificationBanner_appearAnimation__oq8L1","banner":"GlobalNotificationBanner_banner__426x0"};